import React from 'react';
import { useState, useEffect } from 'react'; 
import Box from '@mui/material/Box';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { useTranslation } from 'react-i18next';

import CssBaseline from '@mui/material/CssBaseline';

// Redux 

import menuItems from '../util/navigation/sidebarMenu/support';

// Utils

import { setSideBarMenu } from '../redux/features/general/navigation';

// Components 

import NavBar from '../components/general/navBar/NavBar';
import Sidebar from '../components/general/navigation/Sidebar';
import Notification from '../components/general/notification/Notification';
import Settings from '../components/doctor/navigation/navBar/Settings';

import Container from '../components/support/Container';
import LockScreenWarning from '../components/lockScreen/warning/LockScreenWarning';
import Page from '../components/general/containers/Page';
import TicketDetails from '../components/support/history/formItems/TicketDetails';

const Hacker: React.FC = () => {

  const dispatch = useAppDispatch(); 
  const { t, i18n } = useTranslation();

  const colors = useAppSelector(state => state.theme.colors);
  const section = useAppSelector(state => state.navigation.section);
  const isLockScreenWarningPopupOpened = useAppSelector(state => state.navigation.isLockScreenWarningPopupOpened); 
  const isTicketDetailsPopupOpened = useAppSelector(state => state.navigation.isTicketDetailsPopupOpened); 

  useEffect(() => { 
    dispatch(setSideBarMenu(menuItems(t))); 
  }, [t]); 

  return (

      <Page>

        <NavBar>
          <Settings />
        </NavBar>

        <Sidebar />

        <Container />

        {isTicketDetailsPopupOpened && <TicketDetails />}
        {isLockScreenWarningPopupOpened && <LockScreenWarning />}

      </Page>

  );

};

export default Hacker;